import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';
import { DateService } from 'src/app/services/date.service';
import { SendSurveyReminderComponent } from 'src/app/modal/send-survey-reminder/send-survey-reminder.component';
import { RemovemodalcouponsurveyComponent } from 'src/app/modal/remove-modal-coupon-survey/remove-modal-coupon-survey.component';
import { DatePipe } from '@angular/common';
import Chart from 'chart.js/auto';
import { environment } from '../../../environments/environment';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-survey-report',
  templateUrl: './survey-report.component.html',
  styleUrls: ['./survey-report.component.scss']
})

export class SurveyReportComponent implements OnInit {
  public pollsandsurvey = new Pollsandsurvey();
  private subscriptions = new Subscription();

  public chartbar: Chart;
  public chartpie: Chart;

  surveyId: any;
  surveyDetails: any;
  groupId: string = null;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  couponlogo = 'couponlogo';
  tempDate: any;
  singleCouponId = [];
  fromListPage = 'no';
  formatDate: any;
  selectedDate: any;
  selectedToDate: any;
  formattedSelectedDate: string = '';
  formattedSelectedToDate: string = '';
  fromDate: any;
  fDate: any;
  toDate: any;
  tDate: string;
  mainCouponList = [];
  prakList: any = [];
  parkName: any;
  couponName: any;
  parkId: any;
  public sharedDataNew: any;
  surveyName: any;
  questionTypes = [];
  finalSubmissionArray = [];
  surveyQuestion = [];
  responses = [];
  showPreview: boolean = false;
  arrayForPreview: any;
  mainquestionAnswerList = [];
  showPreviewFromApi: boolean = false;
  arrayForPreviewPreAdded: any;
  singleSurveyDataDelete = [];
  draftSurveyId: any;
  typeOfGraphBar: any;
  typeOfGraphPie: any;
  surveyStatisticsList: any = [];
  totalMemberCount: any;
  respondedMemberCount: any;
  shortAnswerMemberResponseCount: any;
  answerResultData = [];
  responseText = [];
  responsePercent = [];
  chartBackgroundColor = [];
  chartBorderColor = [];
  dataSet = [];
  optData = [];
  active: any;
  showBarChart: any;
  showPieChart: any;
  reminderText: any;
  surveyIdsFinal = [];
  baseUrl;
  surveyRemove: any;
  surveyCreate: any;

  constructor(
    private pollsandsurveyService: PollsandsurveyService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private ngbCalendar: NgbCalendar,
    private route: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavCreateview', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Create and View',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    this.surveyRemove = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:Remove');
    this.surveyCreate = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:Create');
    this.showBarChart = '1';
    this.showPieChart = '1';
    this.active = 1;
    this.destroyChart();
    this.arrayForPreviewPreAdded = [];

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.showPreview = false;
    this.showPreviewFromApi = false;

    this.pollsandsurvey.questionType = '';

    this.route.params.subscribe((params) => {
      this.surveyId = params['id'];
    });

    this.baseUrl = `${environment.apiBaseUrlVegitation}api/v1/Survey/DownloadSurveyReport?surveyId=${this.surveyId}`;
    console.log(this.baseUrl);

    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.getSurveyDetailsSingle();
    this.getSurvetStatissticsList();
  }

  ngOnDestroy() {
    this.destroyChart();
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  destroyChart() {
    if (this.chartbar) {
      this.chartbar.destroy();
      this.chartpie.destroy();
    }
  }

  getSurvetStatissticsList() {
    this.responseText = [];
    this.responsePercent = [];
    this.chartBackgroundColor = [];
    this.chartBorderColor = [];
    this.dataSet = [];
    this.optData = [];
    this.pollsandsurveyService.getStatisticsReportPolls(this.surveyId).subscribe((res) => {
      if (res.isValid) {
        this.surveyStatisticsList = res.data.questions;
        this.totalMemberCount = res.data.totalMemberCount;
        this.respondedMemberCount = res.data.respondedMemberCount;
        this.shortAnswerMemberResponseCount = res.data.shortAnswerMemberResponseCount;
        this.reminderText = res.data.reminderText;
        this.pollsandsurvey.questionId = this.surveyStatisticsList[0].questionId;
        this.pollsandsurveyService.getChartDataByQuestionId(this.pollsandsurvey.questionId).subscribe((res) => {
          if (res.isValid) {
            this.answerResultData = res.data.insights;
            for (let i = 0; i <= this.answerResultData.length - 1; i++) {
              if (this.answerResultData[i].responsePercent > 0) {
                this.responseText.push(this.answerResultData[i].responseText);
                this.responsePercent.push(this.answerResultData[i].responsePercent);
                this.chartBackgroundColor.push(this.answerResultData[i].chartBackgroundColor);
                this.chartBorderColor.push(this.answerResultData[i].chartBorderColor);
                this.dataSet.push({
                  label: this.answerResultData[i].responseText,
                  data: [this.answerResultData[i].responsePercent],
                  backgroundColor: this.answerResultData[i].chartBackgroundColor,
                  borderColor: this.answerResultData[i].chartBorderColor,
                  borderRadius: 10,
                  borderWidth: 1,
                  // barThickness: '50',
                  barPercentage: 0.59,
                  categoryPercentage: 0.85,
                });
              }
            }
            console.log(this.dataSet)
            this.getSurveyResult();
          }
        });
      }
    });
  }

  getQuestionId(event) {

    if (event.target.value != '') {

      this.chartbar.destroy();
      this.chartpie.destroy();

      this.responseText = [];
      this.responsePercent = [];
      this.chartBackgroundColor = [];
      this.chartBorderColor = [];
      this.dataSet = [];
      this.pollsandsurveyService.getChartDataByQuestionId(event.target.value).subscribe((res) => {
        if (res.isValid) {
          this.answerResultData = res.data.insights;
          for (let i = 0; i <= this.answerResultData.length - 1; i++) {
            if (this.answerResultData[i].responsePercent > 0) {
              this.responseText.push(this.answerResultData[i].responseText);
              this.responsePercent.push(this.answerResultData[i].responsePercent);
              this.chartBackgroundColor.push(this.answerResultData[i].chartBackgroundColor);
              this.chartBorderColor.push(this.answerResultData[i].chartBorderColor);
              this.dataSet.push({
                label: this.answerResultData[i].responseText,
                data: [this.answerResultData[i].responsePercent],
                backgroundColor: [this.answerResultData[i].chartBackgroundColor],
                borderColor: [this.answerResultData[i].chartBorderColor],
                borderRadius: 10,
                borderWidth: 1,
                // barThickness: '50',
                barPercentage: 0.59,
                categoryPercentage: 1,
              });
            }
          }
          this.getSurveyResult();
        }
      });
    }
  }

  getSurveyResult() {

    this.typeOfGraphBar = 'bar';

    this.chartbar = new Chart('canvasbar',
      {
        type: "bar",
        data: {
          labels: [''],
          datasets: this.dataSet,
        },
        options: {
          maintainAspectRatio: false, // Set to false to allow custom height
          aspectRatio: 0.4,
          responsive: false,
          indexAxis: 'y',
          scales: {
            y:
            {
              display: false,
              beginAtZero: true,
              grid: {
                display: false,
                // offset: true
              },
            },
            x:
            {
              beginAtZero: true,
              grid: {
                display: true
              },
              // suggestedMax: 100
            },
          },
          plugins: {
            legend: {
              display: true, // Set to false to hide the legend
              position: 'bottom',
              labels: {
                usePointStyle: true,
                pointStyle: 'rectRounded',

                font: {
                  family: 'Montserrat, sans-serif',
                  size: 14,
                  weight: 400
                }
              }
            },
            tooltip: {
              padding: 12,
              displayColors: false,
              bodyFont: {
                family: 'Montserrat, sans-serif',
                size: 13,
                weight: 300,
                lineHeight: 1
              },
            },
          },
        }
      }
    );

    this.typeOfGraphPie = 'pie';

    this.chartpie = new Chart('canvaspie', {
      type: this.typeOfGraphPie,
      data: {
        labels: this.responseText,
        datasets: [
          {
            label: [''],
            data: this.responsePercent,
            backgroundColor: this.chartBackgroundColor,
            borderColor: this.chartBorderColor,
            // borderWidth: 1,
            hoverBorderWidth: 0
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'rectRounded',
              font: {
                family: 'Montserrat, sans-serif',
                size: 14,
                weight: 400
              }
            }
          },
          tooltip: {
            padding: 12,
            displayColors: false,
            bodyFont: {
              family: 'Montserrat, sans-serif',
              size: 13,
              weight: 300,
              lineHeight: 1
            },
          },
        },
        responsive: false,
        maintainAspectRatio: false,
      }
    });
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(
        this.tempDate[2],
        this.tempDate[1] - 1,
        this.tempDate[0]
      );
    } else {
      this.tempDate = date.split('T')[1].split(':');
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM';
      return this.tempDate[0] > 12
        ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type
        : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type;
    }
  }

  gotoEditPage(id) {
    this.router.navigate(['/update-survey/' + id]);
  }

  getSurveyDetailsSingle() {
    this.pollsandsurveyService
      .getSurveyAttributes(this.surveyId)
      .subscribe((res) => {
        if (res?.isValid === true) {
          this.surveyDetails = res;
        }
      });
  }

  getParkDetails() {
    this.pollsandsurveyService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  showHideChartSection(name: any) {
    console.log(name);
    if (name == 'bar') {
      this.showBarChart = '1';
      this.showPieChart = '1';
    }
    if (name == 'pie') {
      this.showBarChart = '1';
      this.showPieChart = '1';
    }
  }

  openModal(surveyId: any): void {

    const modalOptions: NgbModalOptions = {
      size: 'lg',
    };

    const modalRef = this.modalService.open(SendSurveyReminderComponent, modalOptions);
    modalRef.componentInstance.surveyId = surveyId;
    modalRef.componentInstance.reminderMessage = this.reminderText;
  }

  downloadReport(surveyId) {

  }

  openModalRemoveSurvey(): void {

    this.surveyIdsFinal = [];
    this.surveyIdsFinal.push(this.surveyId);

    this.singleSurveyDataDelete.push({
      // "surveyId": this.surveyId,
      "surveyId": this.surveyIdsFinal,
      "deletedBy": localStorage.getItem('claAdminId')
    });

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalcouponsurveyComponent, modalOptions);
    modalRef.componentInstance.surveyId = this.singleSurveyDataDelete[0];
    modalRef.componentInstance.fromDetailsPage = 'yes';
  }
}
